import styled from 'styled-components';
import {
  min_xs,
  min_sm,
  min_md,
  min_lg,
  min_lm,
  min_xl,
  min_fhd,
  max_xs,
  max_sm,
  max_md,
  max_lg,
  max_lm,
  max_xl,
  max_fhd,
} from "../../variables";
import React, { Component } from 'react'
import { BotonOD } from '../common'

export const InfoClienteContainer = styled.div`
position:relative;
.pyme_container{
  display:block;
  position:relative;
  width : 1117px;
  max-width : 100%;
  text-align:right;
  margin:auto;
  @media(${max_md}){
    text-align:center;
  }
}
--wizzard-header-img : 102px;
--wizzard-header-margin-top : 70px;
--wizzard-header-margin-bottom : 15px;

--wizzard-header-font-size : 16px;

@media(${max_md}){
  --wizzard-header-img : 55px;
}

.wizzard__header{
  margin-top : var(--wizzard-header-margin-top);
  margin-bottom : var(--wizzard-header-margin-bottom);
  border-top : 1px solid #F59100;
  height : calc(var(--wizzard-header-img)/2);

  img{
      display:block;
      transform:translateY(-50%);
      width : var(--wizzard-header-img);
      margin:auto;
      padding: 0 16px;
      box-sizing: content-box;
      background: white;
  }

  &__text{
    font-family:Raleway;
    text-align:center;
    font-size : var(--wizzard-header-font-size);
  }
}

  .other_cards{
    text-align:center;
  }
  ${BotonOD}{
    margin:50px auto;
  }

.hero {
  text-align:left;
  margin: 50px auto 40px auto;
  width : 993px; 
  display:inline-block;
  max-width : calc(100% - 40px);
  &__leyenda {
    font-size: 21px;
  }
  &__image_container {
    text-align: right;
    display:inline-block;
    vertical-align:top;

    img {
      max-width: 100%;
    }
  }
  &__description {
    width: calc(100% - 414px);
    display:inline-block;
    box-sizing: border-box;
    vertical-align:top;
    padding-left: 44px;

    @media(${max_md}) {
      width: 100%;
      text-align: center;
      align-items: center;
    }
  }
  &__title {
    font-size: 25px;
    font-weight: 700;
    line-height: 36px;
    margin-top: 40px;
    margin-top:0;
  }
  @media(${min_lg}){
    &__image_container {
      width: 414px;
    }
    &__description {
      width: calc(100% - 414px);
      padding-left: 44px;
    }
    &__title {
      font-size: 45px;
      line-height: 54px;
    }
  }
  @media(${max_lg}) and (${min_md}){
    &__image_container {
      width: 310px;
    }
    &__description {
      width: calc(100% - 310px);
      padding-left: 30px;
    }
    &__title {
      text-align: center;
    }
  }
  @media(${max_md}){
    margin-top:65px;
    &__image_container {
      display:none;
    }
    &__description {
        padding : 0;
        width: 100%;
        text-align: center;
        align-items: center;
        line-height: 21px;
        font-size: 16px;
        line-height: 25px;
      }
  }

  &__imagebox {
    text-align:left;
    
    img {
      width: calc(50% - 15px);
      max-width : 234px;
      display:inline-block;

      :nth-child(2n){
        margin-left : 30px;
      }
    }
    @media(${max_md}){
      max-width : 290px;
      text-align:center;
      margin:auto;
    }
  }
}
.atras_btn {
  position: absolute;
  top: 20px;
  left: 25px;
  text-decoration: none;
  :hover{
    cursor:pointer;
  }

  &.wizzard{
    top:-15px;
    left : 0px;
    transform : translateY(-100%);
  }
}
`

let txtSelectCSS = `

  .txt-select{
    &-arrow{
      position:absolute;
      width : 11.6px;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      opacity : 0.4;
      transition : all 0.3s ease;
      &-hovered{
        opacity : 1;
        transition : all 0.3s ease;
      }
    }
    &-container{
      position:relative;
    }
    &-menu{
      border: 1px solid #9e9e9e;
      border-radius: 4px;
      background-color: hsl(0,0%,100%);
      box-shadow: 0 0 0 1px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1);
      margin-top: 16px;
      max-height:300px;
      overflow-y:auto;
      display:block;
      z-index:1;
      position:relative;
      &-closed{
        display:none;
      }
    }
    &-list{
      padding : 0;
      margin:0;
      list-style-type : none;
    }
    &-item{
      box-sizing:border-box;
      font-size: inherit;
      padding: 8px 12px;
      width: 100%;
      :hover{
        background-color: #cccccc;
        cursor:pointer;
      }
      &-selected{
        color : white;
        background-color: #9e9e9e;
        :hover{
          background-color: #9e9e9e;
        }
      }
    }
  }

`

export const Formulario = styled.div`
    ${props => props.versionC ? `` : `
      background: #FFFFFF;
      box-shadow: 1px 2px 35px rgba(160, 160, 160, 0.195531);
      border-radius: 30px;
    `}
    
    .input-container{
        background: #FFFFFF;
        border: 1px solid rgba(180,180,180,0.7);
        box-sizing: border-box;
        border-radius: 6px;
        height : 45px;
        position:relative;
        .select__indicator-separator{
          display:none;
      }
      .select__menu{
          border: 1px solid #9e9e9e;
      }
      .select__single-value{
        color:inherit;
    }
      .select__menu-list{
          padding : 0;
      }
      .select__option{
          text-align:left;
          :hover{
              background-color: #cccccc;
          }
          &--is-selected{
              background-color: #9e9e9e;
              :hover{
                  background-color: #9e9e9e;
              }
          }
          &--is-focused{
              background-color: #cccccc;
          }
      }
      .select__placeholder{
        color : rgba(158, 158, 158,0.6);
      }
      .select__control{
          border:none;
          border-radius: 6px;
          width : 100%;
          height : 100%;
          font-size: 18px;
          line-height: 23px;
          @media(${max_md}){
            height : 100%;
            font-size : 16px;
          }
          :focus{
              overlay:none;
          }
          &--is-focused{
              box-shadow:none;
          }
      }
    }
    ${txtSelectCSS}
    .label{
      margin-bottom:21px;
      text-align:left;
      position:relative;
      span{
        color: #9E9E9E;
        font-size : 90%;
      }
      @media(${max_md}){
          margin-bottom : 15px;
      }
      &__tooltip{
          position: absolute;
          left: -40px;
          display: inline;
          align-content: center;
          top:5px;
          img{
            width : 17px;
          }
          @media(${max_lg}) {
            top:2px;
            left : -30px;
          }
          @media(${max_md}) {
            top : 1px;
            left : -25px;
          }
          .tooltip_on{
            display: none;
          }
        }

        &__tooltiptext{
          visibility: hidden;
          width: 135px;
          box-sizing: border-box;
          background-color: #555;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          bottom: calc(100% + 12px);
          left: 10px;
          opacity: 0;
          transform:translateX(-50%);
          transition: opacity 0.3s;
          font-size: 12px
          line-height: 1.2;
          padding: 10px;
          text-align: left;
          white-space: normal;
          @media(${max_lg}) {
            left : 56px;
          }
        }
        &__tooltiptext::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #555 transparent transparent transparent;
          @media(${max_lg}) {
            left : 20px;
          }
        }
        &__tooltip:hover{
          .tooltip_on{
            display: unset;
          }
          .tooltip_off{
            display:none;
          }
          .label__tooltiptext{
              visibility: visible;
              opacity: 1;
          }
        }
  }
    .input-content{
        width : calc(100% - 20px);
        height : 100%;
        margin-left : 9px;
        display:block;
        border:none;
        font-size: 18px;
        line-height: 23px;
        letter-spacing: 0.675px;
        color: #4F5D5B;


        ::placeholder{
          color: rgba(158, 158, 158,0.6);
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: 300;
      }
        :focus{
            outline:none;
        }
    }
    @media (${min_md}){
        width : 1117px;
        margin:auto;
        margin-bottom : 40px;
        max-width : calc(100% - 40px);
        text-align:center;
        .form-container{
            width : 1001px;
            max-width : calc(100% - 40px);
            margin: auto;
            margin-top:64px;
            margin-bottom: 45px; 
            display:inline-block;
            text-align:left;
        }
        .input-field{
            margin-bottom:30px;
            display:inline-block;
            vertical-align:top;
            width : 563px;
            max-width : calc(100% - 437px);
            margin-right : 50px;
            :nth-child(2n){
                width : 387px;
                margin-right : 0;
                max-width : unset;
            }
        }
        .input-container{
            width : 100%;
        }
        #pyme_lada_field{
          width : 103px;
          .label.label, .warning-container {
            width : 387px;
          }
        }
        #pyme_number_field{
          width: 270px;
          margin-right : 0;
          margin-left : 10px;
          
        }

    }
    #pyme_number_field{
      .warning-container, .label{
        visibility:hidden;
      }
    }
    @media(${max_md}){
      width : calc(100% - 32px);
      max-width : 400px;
      margin:auto;
      text-align:center;
      .form-container{
        width : calc(100% - 40px);
        margin: auto;
        margin-top:30px;
        margin-bottom: 30px; 
        display:inline-block;
        text-align:left;
    }
      .input-field{
          margin-bottom:25px;
          width : 100%;
          
      }
      .input-content{
        width : calc(100% - 14px);
        height : 100%;
        font-size : 16px;
        margin:auto;
      }
      .input-container{
          width : 100%;
          height : 50px;
      }
      .label{
        margin-bottom : 15px;
      }
      #pyme_lada_field{
        width : 80px;
        .label, .warning-container {
          width : 245px;
        }
        display:inline-block;
        vertical-align:top;
      }
      #pyme_number_field{
        width: calc(100% - 85px);
        display:inline-block;
        vertical-align:top;
        margin-right : 0;
        margin-left : 5px;
      }
    }    
    .active-field{
      border: 1px solid #F7924E;
    }
    .error-field{
        border: 1px solid #ff7366;
    }
    .warning-container{
        text-align:left;
    }
    .warning-content{
        color : #ff7366;
        font-weight : 300;
    }
    .ready-field{
      border: 1px solid #31AD79;
  }
  .ready-field::after{
      content:url('/assets/form/check_verde.png');
      position:absolute;
      top:0;
      right: 0;
      transform: translate(40%, -50%);
    }
`

export const OtherProduct = styled.div`
  background: #FFFFFF;
    box-shadow: 1px 2px 35px rgba(160, 160, 160, 0.195531);
    border-radius: 30px;
    @media (${min_md}){
      width : 1117px;
      margin:auto;
      margin-bottom : 40px;
      max-width : calc(100% - 40px);
      text-align:center;
      box-sizing:border-box;
      padding : 40px 60px;
    }
    .otherProd-title{
      width : 100%;
      position:relative;
      margin-bottom:18px;
      font-family: Raleway;
      font-style: normal;
      font-weight: bold;
      font-size: 35px;
      line-height: 41px;
      color: #4F5D5B;
      text-align:left;
      &__cross{
        position:absolute;
        right : 0px;
        top:50%;
        transform:translateY(-50%);
        width : 13px;
        :hover{
          cursor:pointer;
        }
      }
    }
    .otherProd-info{
      display:inline-block;
      width : 100%;
    }
    .otherProd-button{
      margin-top:40px;
      padding-right : 20px;
      box-sizing : border-box;
      ${BotonOD}{
        margin-left:auto;
      }
    }
    .tarjeta__image{
      display:inline-block;
      width : 50%;
      
      text-align:center;
      vertical-align:top;
      img{
        width : 360px;
        max-width : 96%;
      }
    }
    .tarjeta__beneficios{
      display:inline-block;
      margin-top:30px;
      margin-left : 30px;
      width : calc(50% - 30px);
      text-align:center;
      vertical-align:top;

      &__item{
          margin-bottom:30px;
          text-align:left;

      &__img{
          margin-right : 20px;
          width : 29px;
          display:inline-block;
          vertical-align:middle;
          text-align:center;
          @media (${max_md}){
              vertical-align:top;
              margin-right : 12px;
          }
      }
      &__description{
          margin:0;
          display:inline-block;
          vertical-align:middle;
          text-align:left;
          max-width : calc(100% - 49px);
          height : 20px;
          font-weight: 600;
          
          letter-spacing: -0.18px;

          color: #4F5D5B;
          @media (min-width : 1024px){
              font-size: 18px;
              line-height: 20px;
          }
          @media (max-width : 1023px) and (min-width : 768px){
              font-size: 16px;
              line-height: 18px;
          }
          @media (${max_md}){
              vertical-align:top;
          }
        }
      }
    }
    .half-column{
      width : 50%;
      .tarjeta__image{
        display:inline-block;
        width : 100%;
      }
      .tarjeta__beneficios{
        display:inline-block;
        margin-top:30px;
        margin-left : 0px;
        width : 100%;
        max-width : 475px;
      }

    }
    @media(${max_md}){
      display:none;
    }

`
export const FormularioOtherProduct = styled.div`
    width : 50%;
   
    box-sizing:border-box;
    padding-left :70px;
    vertical-align:top;
    @media(${max_md}){
      margin-top:15px;
      width : 100%;
      padding :0 20px;
    }
    ${props => props.opened ? 'display:inline-block;' : 'display:none;'}
    .input-field{
        margin-bottom:30px;
        @media(${max_md}){
          margin-bottom:20px;
        }
    }
    .label{
      margin-bottom:21px;
      text-align:left;
      position:relative;
      span{
        color: #9E9E9E;
        font-size : 90%;
      }
      @media(${max_md}){
          margin-bottom : 15px;
      }
      &__tooltip{
          position: absolute;
          left: -40px;
          display: inline;
          align-content: center;
          top:5px;
          img{
            width : 17px;
          }
          @media(${max_lg}) {
            top:2px;
            left : -30px;
          }
          @media(${max_md}) {
            top : 1px;
            left : -25px;
          }
          .tooltip_on{
            display: none;
          }
        }

        &__tooltiptext{
          visibility: hidden;
          width: 135px;
          box-sizing: border-box;
          background-color: #555;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          bottom: calc(100% + 12px);
          left: 10px;
          opacity: 0;
          transform:translateX(-50%);
          transition: opacity 0.3s;
          font-size: 12px
          line-height: 1.2;
          padding: 10px;
          text-align: left;
          white-space: normal;
          @media(${max_lg}) {
            left : 56px;
          }
        }
        &__tooltiptext::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #555 transparent transparent transparent;
          @media(${max_lg}) {
            left : 20px;
          }
        }
        &__tooltip:hover{
          .tooltip_on{
            display: unset;
          }
          .tooltip_off{
            display:none;
          }
          .label__tooltiptext{
              visibility: visible;
              opacity: 1;
          }
        }
  }
    .input-container{
        background: #FFFFFF;
        border: 1px solid rgba(180,180,180,0.7);
        box-sizing: border-box;
        position:relative;
        border-radius: 6px;
        width : 171px;
        height : 45px;
        @media(${max_md}){
            width : 100%;
            height : 50px;
        }
        .select__indicator-separator{
          display:none;
      }
      .select__menu{
          border: 1px solid #9e9e9e;
      }
      .select__single-value{
        color:inherit;
    }
      .select__menu-list{
          padding : 0;
      }
      .select__option{
          text-align:left;
          :hover{
              background-color: #cccccc;
          }
          &--is-selected{
              background-color: #9e9e9e;
              :hover{
                  background-color: #9e9e9e;
              }
          }
          &--is-focused{
              background-color: #cccccc;
          }
      }
      .select__placeholder{
        color : rgba(158, 158, 158,0.6);
      }
      .select__control{
          border:none;
          border-radius: 6px;
          width : 100%;
          height : 100%;
          font-size: 18px;
          line-height: 23px;
          @media(${max_md}){
            height : 100%;
            font-size : 16px;
          }
          :focus{
              overlay:none;
          }
          &--is-focused{
              box-shadow:none;
          }
      }
    }
    .input-content{
        width : 142px;
        height : 100%;
        margin-left : 9px;
        display:block;
        border:none;
        letter-spacing: 0.675px;
        color: #4F5D5B;
        font-size: 18px;
        line-height: 23px;
        @media(${max_md}){
            width : calc(100% - 32px);
            height : 20px;
            font-size : 16px;
            margin:auto;
            margin-top:15px;
        }
        ::placeholder{
          color: rgba(158, 158, 158,0.6);
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: 300;
      }
        :focus{
            outline:none;
        }
    }
    .active-field{
      border: 1px solid #F7924E;
    }
    .error-field{
        border: 1px solid #ff7366;
    }
    .warning-container{
        text-align:left;
    }
    .warning-content{
        color : #ff7366;
        font-weight : 300;
    }
    .ready-field{
        border: 1px solid #31AD79;
    }
    .ready-field::after{
        content:url('/assets/form/check_verde.png');
        position:absolute;
        top:0;
        right: 0;
        transform: translate(40%, -50%);
      }
`



export const PrivacidadComponent = styled.div`
    text-align:right;
    margin:auto;
    margin-bottom:30px;
    ${props => props.version == 'B' ? `
    @media(${max_lg}){
      ${BotonOD}{
        display : block;
        margin : auto;
      }
    }
    
    `: ``}
    .checkbox_input{
      display:inline-block;
      vertical-align:middle;
      width : 326px;
      font-size: 18px;
      margin-right : 50px;
      line-height: 1;
      :hover{
        cursor:pointer;
      }
      a{
        color:#F7924E;
        text-decoration:underline;
      }
      span{
        display:inline-block;
        vertical-align:top;
        width : calc(100% - 31px);
        :hover{
          cursor:pointer;
        }
      }
      .warning-container{
          text-align:left;
      }
      .warning-content{
          @media(${max_md}){
            font-size : 14px;
          }
          color : #ff7366;
          font-weight : 300;
      }
    }
    .checkbox_input_v2{
      display : block;
      width : fit-content;
      margin-left:auto;
      margin-right : 0;
      margin-bottom : 50px;

    }
    .checkbox_image{
      display:inline-block;
      vertical-align:top;
      width : 18px;
      margin-right : 13px;
      img{
        width : 100%;
      }
      .checked{
        display:none;
      }
      input{
        display:none;
      }
      input:checked ~ .checked{display:block;}
      input:checked ~ .unchecked{display:none;}
      :hover{
        cursor:pointer;
      }
    }
    @media (${min_md}){
      width : 1117px;
      max-width : calc(100% - 40px);
      ${BotonOD}{
        display:inline-block;
        vertical-align:middle;
      } 
    }    
    @media(${max_md}){
      width : calc(100% - 32px);
      max-width : 400px;
      .checkbox_input{
        display:block;
        margin-top:30px;
        margin-bottom:40px;
        text-align:left;
      }
      .checkbox_input span{
        max-width : 168px;
      }
      ${BotonOD}{
        margin:auto;
      } 
    }

 
`

export const Modal = styled.div`
    ${props => !props.open ? 'display:none;' : ''}
    min-height : 100vh;
    width : 100%;
    min-width : 100vw;
    position:fixed;
    overflow-y:scroll;
    top:0;
    left : 0;
    z-index:99;
    background:rgba(0, 0, 0, 0.32);
    @media(${min_md}){
      ${props => props.mobile ? 'display:none;' : ''}
    }
    .scroll-section{
      @media(${max_md}){
      height : calc(100vh - 10px);
      overflow-y : scroll;
      position: relative;
      ::-webkit-scrollbar {
        display: none;
        }
        -ms-overflow-style: none;
      }
    }
    .container{
      margin:auto;
      margin-top:100px;
      position:relative;
      width : 560px;
      margin-bottom:200px;
      background: #FFFFFF;
      box-shadow: 2px 2px 21px rgba(0, 0, 0, 0.404802);
      border-radius: 16px;
      box-sizing:border-box;
      padding : 20px 40px;
      font-size: 18px;
      line-height: 25px;

      strong{
        margin-bottom:12px;
      }

      .closeModal{
        margin-top: 36px;
        text-align:right;
        a{
          :hover{
            cursor:pointer;
          }
          color: #F7924E;
        }
      }
      @media(${max_md}){
        width : 288px;
        margin-top:50px;
        max-width : calc(100% - 40px);
        box-sizing:border-box;
        padding : 23px 15px;
        font-size: 16px;
        line-height: 24px;

        .closeModal{
          margin-top: 31px;
          a{
            font-size: 18px;
            line-height: 23px
          }
        }
      }
    }
    .otherProd-bottom__cross{
      margin.top:5px;
      width : 100%;
      position:relative;
      text-align:right;
      img{
        width : 10px;
        :hover{cursor:pointer;}
      }
    }
    .otherProd-bottom__next{
      position:absolute;
      bottom: -30px;
      transform:translateY(100%);
      ${BotonOD}{
        margin:auto;
      }
    }
    .otherProd-decline{
      margin-top:35px;
      text-align:center;
      a{
        text-decoration:underline;
        font-size: 16px;
        line-height: 20px;
        :hover{
          cursor:pointer;
        }
        img{
          width : 6px;
          margin-left : 10px;
        }
      }
    }
    .otherProd-title{
      width : 100%;
      position:relative;
      margin-bottom:9px;
      font-family: Raleway;
      font-style: normal;
      font-weight: bold;
      font-size: 22px;
      line-height: 18px;
      color: #4F5D5B;
      text-align:left;
      &__cross{
        position:absolute;
        right : 0px;
        top:50%;
        transform:translateY(-50%);
        width : 13px;
        :hover{
          cursor:pointer;
        }
      }
    }
    .otherProd-info{
      display:inline-block;
      width : 100%;
    }
    .otherProd-button{
      margin-top:40px;
      padding-right : 0;
      box-sizing : border-box;
      ${BotonOD}{
        margin:auto;
      }
    }
    .tarjeta__image{
      width : 100%;
      text-align:center;
      img{
        width : 235px;
        max-width : 96%;
      }
    }
    .tarjeta__header{
      text-align:center;
      font-size: 14px;
      line-height: 18px;
      margin-bottom:17px;
      p{
        margin:0;
      }
      h2{
        font-family: Kabel Dm BT;
        font-size: 20px;
        line-height: 1;
        margin-bottom:10px;
        letter-spacing: -0.5px;

        color: #4F5D5B;
      }
    }
    .tarjeta__beneficios{
      margin-top:10px;
      width : 100%;
      text-align:center;
      vertical-align:top;

      &__item{
          margin-bottom:17px;
          text-align:left;

      &__img{
          width : 20px;
          display:inline-block;
          vertical-align:top;
          margin-right : 12px;
          text-align:center;
          img{
            max-width : 100%;
          }
      }
      &__description{
          margin:0;
          display:inline-block;
          vertical-align:top;
          text-align:left;
          max-width : calc(100% - 49px);
          height : 20px;
          font-weight: 600;
          letter-spacing: -0.18px;
          color: #4F5D5B;
          font-size : 14px;
          line-height : 16px;

          @media(${max_md}){
            height : 35px;
          }
        }
      }
    }

`